// @ts-nocheck
import {
  buildNormalizedAliases,
  buildColumnMap,
  buildRecordFromColumnMap,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const GUJU_FIELD_ALIASES = {
  hospitalName: ['거래처명'],
  drugCode: ['보험코드'],
  drugName: ['제품명'],
  unitPrice: ['단가'],
  quantity: ['수량'],
  prescriptionAmount: ['금액'],
  feeRate: ['제약 수수료율'],
  settlementAmount: ['제약수수료 합계'],
  note: ['제품 비고'],
  pharmaceuticalCompanyName: ['제조사'],
};

const REQUIRED_HEADERS = [
  '정산여부',
  '처방월',
  '정산월',
  '거래처명',
  '제조사',
  '보험코드',
  '제품명',
  '수량',
  '단가',
  '금액',
  '제약 수수료율',
  '제약수수료 합계',
  '제품 비고',
];

function isGujuProfile(profile) {
  return (
    normalizeHeader(profile.sheetName) === normalizeHeader('세부내역') &&
    REQUIRED_HEADERS.every((header) =>
      profile.headers.some(
        (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
      ),
    )
  );
}

const gujuPharmTemplate = {
  id: 'guju-pharm',
  name: '구주제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isGujuProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isGujuProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(GUJU_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const insuranceCode = cleanText(row[columnMap.drugCode]);
      if (!insuranceCode) {
        return;
      }

      const record = buildRecordFromColumnMap({
        row,
        columnMap,
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany: cleanText(
          row[columnMap.pharmaceuticalCompanyName],
        ),
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '구주제약',
      templateName: this.name,
    };
  },
};

export default gujuPharmTemplate;
